export const WEBMAPJS_LAYER_CHANGE_OPACITY = 'WEBMAPJS_LAYER_CHANGE_OPACITY';
export const WEBMAPJS_LAYER_CHANGE_NAME = 'WEBMAPJS_LAYER_CHANGE_NAME';
export const WEBMAPJS_LAYER_CHANGE_STYLE = 'WEBMAPJS_LAYER_CHANGE_STYLE';
export const WEBMAPJS_LAYER_CHANGE_DIMENSION = 'WEBMAPJS_LAYER_CHANGE_DIMENSION';
// export const WEBMAPJS_LAYER_FOCUS = 'WEBMAPJS_LAYER_FOCUS';
export const WEBMAPJS_LAYER_DELETE = 'WEBMAPJS_LAYER_DELETE';
export const WEBMAPJS_SERVICE_SET_LAYERS = 'WEBMAPJS_SERVICE_SET_LAYERS';
export const WEBMAPJS_SERVICE_LAYER_SET_STYLES = 'WEBMAPJS_SERVICE_LAYER_SET_STYLES';
export const WEBMAPJS_LAYER_CHANGE_ENABLED = 'WEBMAPJS_LAYER_CHANGE_ENABLED';
export const WEBMAPJS_SERVICE_LAYER_SET_DIMENSIONS = 'WEBMAPJS_SERVICE_LAYER_SET_DIMENSIONS';
export const WEBMAPJS_LAYER_MOVE = 'WEBMAPJS_LAYER_MOVE';
export const WEBMAPJS_SET_LAYERS = 'WEBMAPJS_SET_LAYERS';
export const WEBMAPJS_SET_BASELAYERS = 'WEBMAPJS_SET_BASELAYERS';
export const WEBMAPJS_SET_FEATURE_LAYERS = 'WEBMAPJS_SET_FEATURE_LAYERS';
export const WEBMAPJS_SET_ACTIVE_MAPPANEL_INDEX = 'WEBMAPJS_SET_ACTIVE_MAPPANEL_INDEX';
export const WEBMAPJS_MAP_CHANGE_DIMENSION = 'WEBMAPJS_MAP_CHANGE_DIMENSION';
export const WEBMAPJS_LAYER_SETHEADERS = 'WEBMAPJS_LAYER_SETHEADERS';
export const WEBMAPJS_START_ANIMATION = 'WEBMAPJS_START_ANIMATION';
export const WEBMAPJS_STOP_ANIMATION = 'WEBMAPJS_STOP_ANIMATION';
